import { render, staticRenderFns } from "./AddnewmoreChoose.vue?vue&type=template&id=43a589f6&scoped=true"
import script from "./AddnewmoreChoose.vue?vue&type=script&lang=js"
export * from "./AddnewmoreChoose.vue?vue&type=script&lang=js"
import style0 from "./AddnewmoreChoose.vue?vue&type=style&index=0&id=43a589f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a589f6",
  null
  
)

export default component.exports